import { render } from "./KontakKami.vue?vue&type=template&id=9a991696"
import script from "./KontakKami.vue?vue&type=script&lang=js"
export * from "./KontakKami.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__